import React, { useRef, useState } from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './AboundSignup.scss';
import Morebtn from '../../../components_v2/desktop/Morebtn';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';

const AboundNumberScreen = ({
  handleOTPScreen,
  errorConfig,
  jssoCrosswalkObj,
}) => {
  const phoneInputRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const countryCode = '+1';

  const handleSendOTP = (ssoid = null, code) => {
    const phoneNumber = phoneInputRef.current.value;
    handleOTPScreen(true, phoneNumber, ssoid, code);
  };

  const checkValidNumber = number => {
    const phoneRegex = /^[2-9]{1}[0-9]{9}$/;
    if (!phoneRegex.test(number)) {
      return false;
    }
    return true;
  };

  const handleChange = () => {
    if (errorMessage) {
      setErrorMessage(false);
    }
  };

  const registerUserCallback = response => {
    setLoader(false);
    // const mobile = phoneInputRef.current.value;
    let errorMsg;
    if (response && response.code === 200) {
      handleSendOTP(response.data.ssoid, countryCode);
    } else if (response.code === 429) {
      errorMsg = errorConfig.userAlreadyRegistered;
    } else if (response.code === 416) {
      errorMsg = errorConfig.limitExceeded;
    } else if (response.code === 503) {
      errorMsg = errorConfig.connectionError;
    } else {
      errorMsg = errorConfig.serverError;
    }
    setErrorMessage(errorMsg);
  };

  const registerUser = () => {
    const mobile = `${countryCode}-${phoneInputRef.current.value}`;
    const jssoObj = jssoCrosswalkObj();
    const fnCall = jssoObj.registerUser;
    if (typeof fnCall === 'function') {
      fnCall.call(
        jssoObj,
        '',
        '',
        '',
        '',
        '',
        mobile,
        `Times@${mobile}`.substring(0, 13),
        '',
        '1',
        '1',
        '0',
        registerUserCallback,
      );
    }
  };

  const handleSignin = () => {
    handleSendOTP(null, countryCode);
  };

  const signInUser = () => {
    const jssoObj = jssoCrosswalkObj();
    const fnCall = jssoObj.getMobileLoginOtp;
    if (typeof fnCall === 'function') {
      fnCall.call(
        jssoObj,
        `${countryCode}-${phoneInputRef.current.value}`,
        handleSignin,
      );
    }
  };

  const checkUserExists = response => {
    let errorMsg;
    if (response && response.code === 200 && response.data) {
      if (
        response.data.statusCode === 212 ||
        response.data.statusCode === 213
      ) {
        signInUser();
      } else if (
        response.data.statusCode === 205 ||
        response.data.statusCode === 206 ||
        response.data.statusCode === 214 ||
        response.data.statusCode === 215
      ) {
        registerUser();
      } else {
        errorMsg =
          response.data.statusCode === 216
            ? errorConfig.fpInvalidEmailOnly
            : errorConfig.fpInvalidEmail;
        setErrorMessage(errorMsg);
        setLoader(false);
      }
    } else {
      if (response.code === 410) {
        errorMsg = errorConfig.fpInvalidMobileOnly;
      } else if (response.code === 503) {
        errorMsg = errorConfig.connectionError;
      } else {
        errorMsg = errorConfig.serverError;
      }
      setErrorMessage(errorMsg);
      setLoader(false);
    }
  };

  const handleMobileClick = e => {
    e.preventDefault();
    e.stopPropagation();
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'get_started_mobile_screen',
      category: 'abound',
    });
    if (!checkValidNumber(phoneInputRef.current.value)) {
      setErrorMessage(errorConfig.fpInvalidEmail);
      setLoader(false);
      return;
    }
    const jssoObj = jssoCrosswalkObj();
    if (typeof jssoObj.checkUserExists === 'function') {
      setLoader(true);
      jssoObj.checkUserExists(
        `${countryCode}-${phoneInputRef.current.value}`,
        checkUserExists,
      );
    }
  };

  return (
    <>
      {loader && <LoaderSpinner />}
      <div className={s.contentHeading}>
        Grab Your <span>$5</span> Welcome Bonus Now
      </div>
      <p className={s.paraText}>
        Start earning more rewards in your Abound wallet by reading articles,
        watching videos on TOI. Brought to you by The Times of India. Sign
        up/Login now and boost your earnings instantly.
      </p>
      <div className={`${s.inputWrap} ${errorMessage ? s.error : ''}`}>
        <span>{countryCode}</span>
        <input
          className={s.phoneNoInput}
          type="tel"
          placeholder="Enter your Mobile Number"
          ref={phoneInputRef}
          maxLength="10"
          onChange={handleChange}
        />
        {errorMessage && <div className={s.errorMsg}>{errorMessage}</div>}
      </div>
      <Morebtn
        moreText="Get Started"
        redbg
        noArrow
        button
        fullWidth
        onClick={handleMobileClick}
      />
    </>
  );
};

export default AboundNumberScreen;
